// Kind-rule predicates shared by the New Transaction entry form and the
// Transaction History edit modal. Both surfaces must agree on which statuses a
// kind offers and when the Expiration / OGL fields apply — keeping the rules
// here prevents the two from drifting apart.
//
// The kind parameter is the structural union rather than an import of
// InterestKind (pages/NewTransactionPage/types.ts) so lib never depends on a
// page module; the types are identical.

/** Statuses a user may pick for an ACQ of the given kind. "Open" (unleased —
 *  full royalty) exists only on mineral interests. */
export function interestStatusOptions(kind: "leasehold" | "mineral"): string[] {
  return kind === "mineral" ? ["Open", "PT", "HBP"] : ["PT", "HBP"]
}

/** Expiration applies to ACQ rows in their primary term (server clears it
 *  otherwise). */
export function showExpiration(type: string, status: string): boolean {
  return type === "ACQ" && status === "PT"
}

/** The OGL (lease detail) group applies to leased mineral acquisitions only
 *  (server clears the fields otherwise). */
export function showOgl(kind: "leasehold" | "mineral", type: string, status: string): boolean {
  return kind === "mineral" && type === "ACQ" && (status === "PT" || status === "HBP")
}
